import {TDShapeType, getSession, SessionArgsOfType, TldrawSession, EraseTool, TextTool, DrawTool, EllipseTool, RectangleTool, ArrowTool, StickyTool, ToolsMap, ToolInstancesMap, LineTool, WhiteboardToolType, FrameTool, HighlighterTool} from '@modules/whiteboard'
import {action, observable, _} from '@api'
import {SessionType, TDToolType, WhiteboardStore} from './'
import {BaseTool, SelectTool } from '@modules/whiteboard'

export class WhiteboardToolStore {
  constructor(public store: WhiteboardStore) {
    this.tools  = {
      select: new SelectTool(store),
      erase: new EraseTool(store),
      text: new TextTool(store),
      draw: new DrawTool(store),
      highlighter: new HighlighterTool(store),
      ellipse: new EllipseTool(store),
      rectangle: new RectangleTool(store),
      line: new LineTool(store),
      arrow: new ArrowTool(store),
      sticky: new StickyTool(store),
      frame: new FrameTool(store)
    }

    this.currentTool = this.tools[store.appState.activeTool ?? 'select']
  }

  @observable.ref currentTool : BaseTool

  get ui() { return this.store.ui}
  get appState() { return this.store.appState}
  get isToolLocked() { return this.appState.isToolLocked}
  set isToolLocked(v) { this.appState.isToolLocked = v}
  @observable.ref tools : ToolInstancesMap


  get settings() { return this.store.settings }
  /**
   * Select a tool.
   * @param tool The tool to select, or "select".
   */
  @action selectTool = (type: TDToolType) => {
    const tool = this.tools[type],
      {currentTool, appState} = this

    // console.trace(`selectTool`, {type})
    this.isToolLocked = false

    if (!tool) throw new Error(`Unknown tool type ${type}`)

    appState.activeTool = type
    if (tool !== currentTool) {
      currentTool.onExit()

      tool.previous = currentTool.type
      this.currentTool = tool
      this.currentTool.onEnter()
      appState.activeTool = type
    }
  }

  /**
   * Toggle the tool lock option.
   */
  @action toggleToolLock = () => {
    this.isToolLocked = !this.isToolLocked
  }

  /// region Sessions

  @observable session?: TldrawSession
  @observable isCreating = false

  /* -------------------------------------------------- */
  /*                      Sessions                      */
  /* -------------------------------------------------- */

  get readOnly() { return this.store.readOnly}

  /**
   * Start a new session.
   * @param session The new session
   * @param args arguments of the session's start method.
   */
  @action startSession = <T extends SessionType>(type: T, ...args: SessionArgsOfType<T>) => {
    if (this.readOnly && type !== SessionType.Brush) return this
    this.store.undo_end()

    if (this.session) {
      console.warn(`Already in a session! (${this.session.constructor.name})`)
      this.cancelSession()
    }

    const Session = getSession(type)

    if (Session) {
      // @ts-ignore
      this.session = new Session(this.store, ...args)

      const result = this.session.start()
    }
  }

  /**
   * updateSession.
   * @param args The arguments of the current session's update method.
   */
  @action updateSession = () => {
    const { session } = this
    if (!session) return this

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const patch = session.update()
  }

  /**
   * Cancel the current session.
   * @param args The arguments of the current session's cancel method.
   */
  @action cancelSession = () => {
    const { session } = this
    if (!session) return this
    this.session = undefined

    const result = session.cancel()
  }

  /**
   * Complete the current session.
   * @param args The arguments of the current session's complete method.
   */
  @action completeSession = () => {
    const { session, store: {appState, myPageState} } = this

    if (!session) return
    this.session = undefined
    const result = session.complete()

    if (result === undefined) {
      this.isCreating = false

      _.assign(appState, {
        status: 'idle',
        editingId: undefined,
        bindingId: undefined,
        hoveredId: undefined,
      })
    } else if ('after' in result) {
      // Session ended with a command

      if (this.isCreating) {
        if (this.isToolLocked) {
          myPageState.selectedIds = []
        }

        this.isCreating = false
      }

      appState.status = 'idle'
      appState.editingId = null
    } else {
      appState.status = 'idle'
      appState.editingId = null
    }

    return this
  }

  /// endregion

}


// WEBPACK FOOTER //
// ./src/modules/whiteboard/WhiteboardToolStore.ts